// src/components/BestTour.js

import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom

import trending1 from '../images/service/1.jpg';
import trending2 from '../images/service/2.jpg';
import trending3 from '../images/service/3.jpg';
import trending4 from '../images/service/4.jpg';

const BestTour = () => {
  const tourPackages = [
    {
      id: 1,
      image: trending2,
      location: 'Anand Krushi Paryatan Kendra ',
      title: 'Pune nearby attractions',
      days: '2 Days Tour',
      price: 170,
      rating: 12,
      description: 'Explore famous historical and natural sites near Pune perfect for weekend getaways with family and friends.',
      link: '/Pune-Nearby-Attractions',
    },
    {
      id: 2,
      image: trending3,
      location: 'Anand Krushi Paryatan Kendra',
      title: 'Day tour destinations near Morachi Chincholi Pune',
      days: '1 Day Tour',
      price: 180,
      rating: 38,
      description: 'Ideal for quick breaks, this day tour includes peacock watching, local food, and rural farm activities.',
      link: '/Day-Tour-Destinations-Near-Morachi-Chincholi-Pune',
    },
    {
      id: 3,
      image: trending4,
      location: 'Anand Krushi Paryatan Kendra',
      title: 'One day picnic spot near Pune at Morachi Chincholi',
      days: '1 Day Tour',
      price: 260,
      rating: 18,
      description: 'Perfect for families, this picnic package offers bullock cart rides, games, lunch, and village fun all in one day.',
      link: '/One-Day-Picnic-Spot-Near-Pune-at-Morachi-Chincholi',
    },
    {
      id: 4,
      image: trending1,
      location: 'Anand Krushi Paryatan Kendra',
      title: 'Day trip destinations near Morachi Chincholi Pune',
      days: '1 Day Tour',
      price: 180,
      rating: 38,
      description: 'A blend of relaxation and rural charm, enjoy a full day of nature, traditional food, and peaceful landscapes.',
      link: '/Day-Trip-Destinations-Near-Morachi-Chincholi-Pune',
    },
  ];

  return (
    <section className="trending bg-grey pt-17 pb-6">
      <div className="section-shape top-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
      <div className="container">
        <div className="row align-items-center justify-content-between mb-6">
          <div className="col-lg-7">
            <div className="text-center text-lg-start">
              <h4 className="mb-1 theme1">Our Top Notch Services</h4>
              <h2 className="mb-1">
                Find Best <span className="theme">Services for You</span>
              </h2>
              <p>
                We offer a wide range of services, including tour packages, accommodation, and activities, ensuring a comfortable and enjoyable experience for our guests.
              </p>
            </div>
          </div>
          <div className="col-lg-5"></div>
        </div>

        <div className="trend-box">
          <Swiper
            spaceBetween={30}
            slidesPerView={3}
            loop={true}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
            }}
            breakpoints={{
              320: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
          >
            {tourPackages.map((tour) => (
              <SwiperSlide key={tour.id}>
                <div className="trend-item rounded box-shadow bg-white">
                  <div className="trend-image position-relative">
                    <img src={tour.image} alt={tour.title} className="img-fluid" />
                    <div className="color-overlay"></div>
                  </div>
                  <div className="trend-content p-4 pt-5 position-relative">
                    <div className="trend-meta bg-theme white px-3 py-2 rounded">
                      <div className="entry-author">
                        <i className="icon-calendar"></i>
                        <span className="fw-bold">{tour.days}</span>
                      </div>
                    </div>
                    <h3 className="mb-1">
                      <Link to={tour.link}>{tour.title}</Link>
                    </h3>
                    <div className="rating-main d-flex align-items-center pb-2">
                      {/* You can add star icons or ratings here */}
                    </div>
                    <p className="border-b pb-2 mb-2">{tour.description}</p>
                    <h5 className="theme mb-1">
                      <i className="flaticon-location-pin"></i> {tour.location}
                    </h5>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default BestTour;
